'use strict';

angular.module('internal.applications', ['ngAnimate', 'ui.bootstrap'])
    .config(['$stateProvider', '$urlRouterProvider', function ($stateProvider, $urlRouterProvider) {
        $stateProvider
            // internal routings
            // applications tab
            .state('internal.licensing.application', {
                abstract: true,
                templateUrl: paths.app + 'applications/components/application/application.html',
                controller: 'InternalApplication',
                params: {
                    id: null,
                    application: null
                }
            })
                .state('internal.licensing.application.responses', {
                    url: '/application/:id/responses',
                    templateUrl: paths.app + 'applications/components/application-responses/application-responses.html',
                    controller: 'InternalApplicationResponses',
                    params: {
                        id: null,
                        application: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view(this.self.name).then(function (access) {
                                if (!access) {
                                    $state.go('internal.licensing.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.licensing.application.response', {
                    url: '/application/:id/response/:responseID/:fireStartTrigger',
                    templateUrl: paths.app + 'applications/components/application-response/application-response.html',
                    controller: 'InternalApplicationResponse',
                    params: {
                        id: null,
                        application: null,
                        responseID: null,
                        response: null,
                        fireStartTrigger: null
                    },
                    resolve: {
                        permission: ['$state', '$stateParams', '$rootScope', 'Permissions', function ($state, $stateParams, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;

                            var method = 'view';
                            if ($stateParams.id == null) {
                                method = 'add';
                            }

                            return Permissions[method]('internal.licensing.application.responses').then(function (access) {
                                if (!access) {
                                    $state.go('internal.licensing.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.licensing.application.forms', {
                    url: '/application/:id/forms/:licenseID',
                    templateUrl: paths.app + 'applications/components/application-forms/application-forms.html',
                    controller: 'InternalApplicationForms',
                    params: {
                        id: null,
                        application: null,
                        licenseID: null
                    },
                    resolve: {
                        permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                            $rootScope.$state.current = this.self;
                            return Permissions.view('internal.licensing.application.responses').then(function (access) {
                                if (!access) {
                                    $state.go('internal.licensing.denied');
                                }
                            });
                        }]
                    }
                })
                .state('internal.licensing.application.payments', {
                    abstract: true,
                    templateUrl: paths.app + "applications/components/application-payments/application-payments.html",
                    params: {
                        id: null,
                        application: null
                    }
                })
                    .state('internal.licensing.application.payments.initiate', {
                        url: '/application/:id/payments/initiate',
                        templateUrl: paths.app + 'applications/components/application-payments-initiate-transaction/application-payments-initiate-transaction.html',
                        controller: 'InternalApplicationPaymentsInitiate',
                        params: {
                            id: null,
                            application: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.parent.self.name).then(function (access) {
                                    if (!access) {
                                        $state.go('internal.licensing.denied');
                                    }
                                });
                            }]
                        }
                    })
                    .state('internal.licensing.application.payments.checkout', {
                        url: '/application/:id/payments/checkout',
                        templateUrl: paths.app + 'applications/components/application-payments-gateway/application-payments-gateway.html',
                        controller: 'InternalApplicationPaymentsCheckout',
                        params: {
                            id: null,
                            application: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.parent.self.name).then(function (access) {
                                    if (!access) {
                                        $state.go('internal.licensing.denied');
                                    }
                                });
                            }]
                        }
                    })
                    .state('internal.licensing.application.payments.responsenoaction', {
                        url: '/application/payments/response',
                        templateUrl: paths.app + 'applications/components/application-payments-gateway/application-payments-gateway.html',
                        controller: 'InternalApplicationPaymentsCheckout',
                        params: {
                            actionString: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.parent.self.name).then(function (access) {
                                    if (!access) {
                                        $state.go('internal.licensing.denied');
                                    }
                                });
                            }]
                        }
                    })
                    .state('internal.licensing.application.payments.response', {
                        url: '/application/payments/response/:actionString',
                        templateUrl: paths.app + 'applications/components/application-payments-gateway/application-payments-gateway.html',
                        controller: 'InternalApplicationPaymentsCheckout',
                        params: {
                            actionString: null
                        },
                        resolve: {
                            permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                                $rootScope.$state.current = this.self;
                                return Permissions.view(this.parent.self.name).then(function (access) {
                                    if (!access) {
                                        $state.go('internal.licensing.denied');
                                    }
                                });
                            }]
                        }
                    })
            .state('internalNH.applicationStartPreview', {
                url: '/application/start/preview/:previewUserId',
                templateUrl: paths.app + 'applications/components/application-react/application-react.html',
                controller: 'InternalApplicationReact',
                params: {
                    previewUserId: null
                }
            })
            .state('internalNH.applicationContinueListPreview', {
                url: '/application/continue/list/preview/:previewUserId',
                templateUrl: paths.app + 'applications/components/application-react/application-react.html',
                controller: 'InternalApplicationReact',
                params: {
                    previewUserId: null
                }
            })
            .state('internalNH.applicationContinuePreview', {
                url: '/applications/continue/preview/:userID',
                templateUrl: paths.app + 'applications/components/public-applications-preview/applications.html',
                controller: 'InternalApplicationsPreview',
                params: {
                    userID: null,
                    review: false
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                //$state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('internalNH.applicationReviewPreview', {
                url: '/applications/review/preview/:userID',
                templateUrl: paths.app + 'applications/components/public-applications-preview/applications.html',
                controller: 'InternalApplicationsPreview',
                params: {
                    userID: null,
                    review: true
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'PortalPermissions', function ($state, $rootScope, PortalPermissions) {
                        $rootScope.$state.current = this.self;
                        return PortalPermissions.view(this.self.name).then(function (access) {
                            if (!access) {
                                //$state.go('portal.menus.denied');
                            }
                        });
                    }]
                }
            })
            .state('internalNH.stylesheetPreview', {
                url: '/stylesheets/preview/:id',
                templateUrl: paths.app + 'applications/components/stylesheet-preview/stylesheet-preview.html',
                controller: 'InternalStylesheetPreview',
                params: {
                    id: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view(this.self.name).then(function (access) {

                        });
                    }]
                }
            })
            .state('internalNH.applicationCheckoutListPreview', {
                url: '/application/checkout/list/preview/:previewUserId',
                templateUrl: paths.app + 'applications/components/application-react/application-react.html',
                controller: 'InternalApplicationReact',
                params: {
                    previewUserId: null
                }
            })
            .state('internalNH.applicationMyListPreview', {
                url: '/application/mylist/preview/:previewUserId',
                templateUrl: paths.app + 'applications/components/application-react/application-react.html',
                controller: 'InternalApplicationReact',
                params: {
                    previewUserId: null
                }
            })
            .state('internalNH.applicationServiceListPreview', {
                url: '/application/servicelist/preview/:previewUserId',
                templateUrl: paths.app + 'applications/components/application-react/application-react.html',
                controller: 'InternalApplicationReact',
                params: {
                    previewUserId: null
                }
            })
            .state('internalNH.applicationHistoryPreview', {
                url: '/application/history/preview/:previewUserId',
                templateUrl: paths.app + 'applications/components/application-react/application-react.html',
                controller: 'InternalApplicationReact',
                params: {
                    previewUserId: null
                }
            })
            .state('internal.licensing.application.educationReport', {
                url: '/education/user/:id/:userId/:levelId',
                templateUrl: paths.app + 'applications/components/application-react/application-react.html',
                controller: 'InternalApplicationReact',
                params: {
                    id: null,
                    userId: null,
                    levelId: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view('internal.licensing.application.educationReport').then(function (access) {
                            if (!access) {
                                $state.go('internal.licensing.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.licensing.application.educationApplicationReport', {
                url: '/education/user/:id/:userId/',
                templateUrl: paths.app + 'applications/components/application-react/application-react.html',
                controller: 'InternalApplicationReact',
                params: {
                    id: null,
                    userId: null,
                    levelId: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view('internal.licensing.application.educationReport').then(function (access) {
                            if (!access) {
                                $state.go('internal.licensing.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.licensing.application.applicationEducationCourseList', {
                url: '/education/userCourseList/:id/:userId',
                templateUrl: paths.app + 'applications/components/application-react/application-react.html',
                controller: 'InternalApplicationReact',
                params: {
                    id: null,
                    userId: null,
                    levelId: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view('internal.licensing.application.educationCourseList').then(function (access) {
                            if (!access) {
                                $state.go('internal.licensing.denied');
                            }
                        });
                    }]
                }
            })
            .state('internal.licensing.application.applicationEducationCourseLevelList', {
                url: '/education/userCourseList/:id/:userId/:levelId',
                templateUrl: paths.app + 'applications/components/application-react/application-react.html',
                controller: 'InternalApplicationReact',
                params: {
                    id: null,
                    userId: null,
                    levelId: null
                },
                resolve: {
                    permission: ['$state', '$rootScope', 'Permissions', function ($state, $rootScope, Permissions) {
                        $rootScope.$state.current = this.self;
                        return Permissions.view('internal.licensing.application.educationCourseList').then(function (access) {
                            if (!access) {
                                $state.go('internal.licensing.denied');
                            }
                        });
                    }]
                }
            })
    }])
;